package org.hs_soft.runmynesto.domain.model.home.closing_reports
import org.hs_soft.runmynesto.domain.util.helper.LanguageManager

enum class PaymentMethodTableHeadersEnum(
    val title: String,
    val isNumeric: Boolean = false,
    val key: String
) {
    CREDIT(
        title = LanguageManager.getCurrentStrings().credit,
        key = "credit"
    ),
    NUMBER(
        title = LanguageManager.getCurrentStrings().number,
        isNumeric = true,
        key = "number"
    ),
    AMOUNT(
        title = LanguageManager.getCurrentStrings().amount,
        isNumeric = true,
        key = "amount"
    );
}